import { Component, OnInit, ViewContainerRef, HostListener, EventEmitter, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import {ConstantMessages} from '../common/ConstantMessages';
import { ToastrService } from 'ngx-toastr';
//import { Cookie } from 'ng2-cookies/ng2-cookies';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isPlatformServer } from '@angular/common';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { SeoService } from 'src/app/seo.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { windowScreen } from 'src/app/services/utility.service';
import { LoginComponent } from 'src/app/shared/components/Login/Login.component';
import { CategoryFiltersComponent } from '../category-filters/category-filters.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterCategory } from 'src/app/shared/interface/shared-interface';
//import * as $ from 'jquery';

@Component({
  selector: 'videocategory',
  templateUrl: './videocategory.component.html',
  styleUrls: ['./videocategory.component.css'],
  providers: [HTTPService, MessageService]
})

export class VideoCategoryComponent implements OnInit, OnDestroy {
  public constants: Constants;
  public constantMessages: ConstantMessages;
  public pageSize: any = 0;
  public messageType: any;
  public screen: string = 'mobile';
  public VideoFilterModel = { videoId: 0, categoryId: 0, SubcategoryId: 0, StartRow: 0, PageSize: 1000, ScreenType: 1, IsMainHomePageRequest: false }
  AllVideoData: any = [];
  allVideoOriginalData: any = [];
  public CategoryData: any;

  public pageTitle: string = '';
  public isAllVideoLoading: boolean = false;
  public isShowLoader: boolean = false;
  public isShowNoContent: boolean = false;
  public isAllVideoLoaded: boolean = false;
  public categoryName: string;
  public categoryNameTitle: string;
  public subCategoryName: string;
  public categorySlug: string;
  assetURL = environment.assetURL;
  soryByData: FilterCategory[] = [];
  photoFilterData: FilterCategory[] = [];
  videoCategoryData: FilterCategory[] = [];
  selectedTag: FilterCategory[] = [];
  selectedOptions: string[] = [];
  categorydata: any;
  currentCategory;
  //AllVideoData = this.homedata1.homepageData;
  subscription = new Subscription();
  constructor(private dialog: MatDialog,
    private _httpService: HTTPService, private _router: Router, private _route: ActivatedRoute,
    private messageService: MessageService, public toastr: ToastrService, vcr: ViewContainerRef, private modalService: NgbModal,
    private sharedService: SharedService, private seoService: SeoService, @Inject(PLATFORM_ID) private platformId) {
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
    if (!isPlatformServer(this.platformId))
      window.addEventListener('resize', this.handleWindowResize);

    // window.addEventListener('scroll', this.onScroll);
    // this.GetCategoryWiseVideoDataList();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    //this.login();
    var a = this.sharedService.userToEdit;
    // window.scrollTo(0, 0);
    this.subscription.add(
      this._route.paramMap.subscribe(params => {
        this.clearFilter();
        this.videoCategoryData = [];
        this.soryByData = [];
        this.photoFilterData = [];
        this.VideoFilterModel = { videoId: 0, categoryId: 0, SubcategoryId: 0, StartRow: 0, PageSize: 1000, ScreenType: 1, IsMainHomePageRequest: false };
        const queryData = this.sharedService.decryptAndParseQueryString(params.get("data"));
        if (queryData != undefined) {
          this.VideoFilterModel.categoryId = queryData.categoryId ?? 0;
          this.VideoFilterModel.SubcategoryId = queryData.subCategoryId ?? 0;
        }
        this.AllVideoData = [];
        this.VideoFilterModel.StartRow = 0;
        this.isAllVideoLoading = false;
        this.isAllVideoLoaded = false;
        this.categoryName = params.get("category");
        this.subCategoryName = params.get("subCategory");
        this.categorySlug = params.get("categorySlug");
        if (this.VideoFilterModel.categoryId || this.VideoFilterModel.SubcategoryId > 0) {
          this.GetCategoryWiseVideoDataList();
          this.GetCategoryDataList();
          if (this.subCategoryName == null)
            this.subCategoryName = this.categoryName;
          this.categoryNameTitle = this.categoryName == "More" || this.VideoFilterModel.SubcategoryId > 0 ? this.subCategoryName : this.categoryName;
        }
        else {
          this.GetCategoryFromSlug();
        }
        this.soryByData.push({ Id: 1, Name: "Most Popular", Category: 2 }, { Id: 2, Name: "Newest", Category: 2 });
        this.photoFilterData.push({ Id: 1, Name: "With Photo", Category: 3 }, { Id: 2, Name: "Without Photo", Category: 3 });
      }));
    if (!isPlatformServer(this.platformId))
      this.handleWindowResize();

  }

  ShowMobileFiltersDialog(): void {
    const modalReference = this.modalService.open(CategoryFiltersComponent, {
      size: "lg",
      centered: true,
      backdrop: "static"
    });
    modalReference.componentInstance.categoryName = this.categoryName;
    modalReference.componentInstance.soryByData = this.soryByData;
    modalReference.componentInstance.photoFilterData = this.photoFilterData;
    modalReference.componentInstance.videoCategoryData = this.videoCategoryData;
    modalReference.componentInstance.selectedTag = this.selectedTag;
    modalReference.componentInstance.selectedOptions = this.selectedOptions;
    modalReference.result.then((result: any) => {
      this.selectedTag = result.selectedTag;
      this.selectedOptions = result.selectedOptions;
      this.filterData();
    });
  }

  ngAfterViewInit(): void {

  }

  handleWindowResize = (): void => {
    this.screen = windowScreen();
  }

  changeContentVisibility(category: any) {
    category.IsShowMore = !category.IsShowMore;
  }

  public GetCategoryDataList() {
    if (this.sharedService.videoCategoryData != undefined) {
      this.GenerateSeoTags();
    }
    else {
      this.sharedService.isVideoCategoryDataAvailable.subscribe(
        (data: any) => {
          if (data) {
            this.GenerateSeoTags();
          }
        }
      );
    }

    if (this.sharedService.videoCategoryData != null && this.sharedService.videoCategoryData != undefined) {
      this.CategoryData = this.sharedService.videoCategoryData;
      this.processCategoryData();
    }
    else {
      this.subscription.add(
        this._httpService.ajaxPost('homepage/GetCategoryData', { pCategoryId: "0" }).subscribe(
          data => {
            if (data["Message"].MessageTypeValue == this.messageType.Success) {

              this.CategoryData = data["CategoryData"];
              this.processCategoryData();
            }
            else if (data["Message"].MessageTypeValue == 6) {
              this.isAllVideoLoaded = true;
            }
            else {
              this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
            }
          },
          (error: any) => {
            // this.hideSpinner();
            // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
          }));
    }
  }

  private processCategoryData() {
    this.categorydata = this.CategoryData.filter(x => x.CategoryId == this.VideoFilterModel.categoryId)[0];
    this.pageTitle = "";
    if (this.categorydata != null && this.categorydata != "") {
      this.pageTitle = "Customizable Invitations for " + this.categorydata.CategoryDesc;
    }
    this.categorydata?.SubCategoryData.forEach(subCategory => {
      this.videoCategoryData.push({ Id: subCategory?.SubCategoryId, Name: subCategory?.SubCategoryName, Category: 1 });
    });
    if (this.VideoFilterModel.SubcategoryId == 0) {
      this.videoCategoryData.forEach(x => {
        x.IsSelected = true;
        this.selectedTag.push(x);
      });
    }
    else {
      let selectedItem = this.videoCategoryData.filter(x => x.Id == this.VideoFilterModel.SubcategoryId)[0];
      selectedItem.IsSelected = true;
      this.selectedTag.push(selectedItem);
    }
  }

  private GenerateSeoTags() {

    if (this.VideoFilterModel.SubcategoryId == 0) {
      this.currentCategory = this.sharedService.videoCategoryData.filter(x => x.CategoryId == this.VideoFilterModel.categoryId)[0];
    }
    else {
      this.currentCategory = this.sharedService.videoCategoryData
        .filter(x => x.CategoryId == this.VideoFilterModel.categoryId)[0].SubCategoryData
        .filter(y => y.SubCategoryId == this.VideoFilterModel.SubcategoryId)[0];
    }
    if (this.currentCategory != null && this.currentCategory != undefined) {
      this.seoService.generateTags({
        title: this.currentCategory.MetaTitle,
        description: this.currentCategory.MetaDescription,
        image: `${this.assetURL}/assets/images/logo.png`,
        keywords: this.currentCategory.MetaKeywords
      });
    }
  }

  public GetCategoryFromSlug() {
    var objRequest = Object.assign({});
    objRequest.CategorySlug = this.categorySlug;
    this.sharedService.isShowLoader.next(true);
    this.subscription.add(
      this._httpService.ajaxPost('homepage/GetCategoryFromSlug', objRequest).subscribe((data: any) => {
        this.VideoFilterModel.categoryId = data.CategoryId;
        this.VideoFilterModel.SubcategoryId = data.SubCategoryId;
        this.categoryName = data.CategoryName;
        this.subCategoryName = data.SubCategoryName;
        if (data.CategoryId == 0 && data.SubCategoryId == 0) {
          this._router.navigate(['']);
        }
        if (this.subCategoryName == null)
          this.subCategoryName = this.categoryName;
        this.categoryNameTitle = this.categoryName == "More" || data.SubCategoryId > 0 ? this.subCategoryName : this.categoryName;
        this.GetCategoryWiseVideoDataList();
        this.GetCategoryDataList();
      }));
  }

  public GetCategoryWiseVideoDataList() {
    if (this.isAllVideoLoading) return false;
    this.isAllVideoLoading = true;
    // this.AllVideoData = this.homedata1.homepageData;
    var objRequest = { ...this.VideoFilterModel };
    objRequest.SubcategoryId = 0;
    this.subscription.add(
      this._httpService.ajaxPost('homepage/GetHomepageData', objRequest).subscribe((data: any) => {
        if (data["Message"].MessageTypeValue == this.messageType.Success) {

          var allVideoData = data["AllVideoCardData"];
          if (allVideoData != null && allVideoData.length > 0) {
            allVideoData.forEach(element => {
              this.AllVideoData.push(element);
            });
            this.allVideoOriginalData = [...allVideoData];
          }
          else {
            this.isShowNoContent = true;
          }
          this.sharedService.isShowLoader.next(false);
          this.filterData();
          // if (!isPlatformServer(this.platformId))
          //   window.addEventListener('scroll', this.onScroll, true); //third parameter

        }
        else if (data["Message"].MessageTypeValue == 6) {
          this.isAllVideoLoaded = true;
          this.sharedService.isShowLoader.next(false);
          this.isShowNoContent = true;
        }
        else {
          this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
          this.sharedService.isShowLoader.next(false);
        }
        this.isAllVideoLoading = false;
      },
        (error: any) => {
          // this.hideSpinner();
          // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
        }));
  }

  bottomReached(): boolean {
    return Math.round(window.innerHeight + window.scrollY) >= document.body.offsetHeight;
  }

  // @HostListener("window:scroll", [])
  onScroll = (event): void => {
    const bottomReached = Math.round(window.innerHeight + window.scrollY) >= document.body.offsetHeight;
    if (bottomReached) {
      if (this.isAllVideoLoaded) return;
      this.VideoFilterModel.StartRow = this.AllVideoData.length;
      this.GetCategoryWiseVideoDataList();
    }

  }
  showMore() {
    if (this.isAllVideoLoaded) return;
    this.VideoFilterModel.StartRow = this.AllVideoData.length;
    this.GetCategoryWiseVideoDataList();
  }
  openDialog(): void {
    this.dialog.open(LoginComponent)
  }

  public openVideoPage(item) {
    let encryptedqueryparams: { videoId: any; };
    encryptedqueryparams = {
      videoId: item?.VideoId
    };
    this._router.navigate([`/${item.NameEnglish.replace(/ +/g, "-")}/video/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
  }
  setPhotoFilter(item: FilterCategory) {
    item.IsSelected = true;
    this.selectedTag = this.selectedTag.filter(x => x.Category != 3);
    this.selectedTag.push(item);
    this.filterData();
  }
  setSortFilter(item: FilterCategory) {
    item.IsSelected = true;
    this.selectedTag = this.selectedTag.filter(x => x.Category != 2);
    this.selectedTag.push(item);
    this.filterData();
  }
  setCategoryFilter(item: FilterCategory) {
    item.IsSelected = true;
    // this.selectedTag.push(item);
    this.filterData();
  }
  toggleSelection(subCategoryDataItem: FilterCategory) {
    subCategoryDataItem.IsSelected = !subCategoryDataItem.IsSelected;
    if (subCategoryDataItem.IsSelected) {
      this.selectedTag.push(subCategoryDataItem);
    }
    else {
      this.selectedTag = this.selectedTag.filter(tag => !(tag.Category === subCategoryDataItem.Category && tag.Id === subCategoryDataItem.Id));
    }
    this.filterData();
  }

  isSelected(option: string): boolean {
    return this.selectedOptions.includes(option);
  }
  filterData() {
    this.AllVideoData = this.allVideoOriginalData;
    if (this.selectedTag.length > 0) {
      if (this.selectedTag.filter(x => x.Category == 3).length > 0) {
        let photoFilter = this.selectedTag.filter(x => x.Category == 3)[0];
        this.AllVideoData = photoFilter.Id == 1 ? this.AllVideoData.filter(x => x.NumberOfPhotos > 0) : this.allVideoOriginalData.filter(x => x.NumberOfPhotos == 0);
      }
      if (this.selectedTag.filter(x => x.Category == 2).length > 0) {
        let sortFilter = this.selectedTag.filter(x => x.Category == 2)[0];
        this.AllVideoData = sortFilter.Id == 1 ? this.AllVideoData.sort((a, b) => b.NumberOfViews - a.NumberOfViews) : this.AllVideoData.sort((a, b) => b.VideoId - a.VideoId);
      }
      if (this.selectedTag.filter(x => x.Category == 1).length > 0) {
        const subCategoryIds = this.selectedTag.map(tag => tag.Id);
        this.AllVideoData = this.AllVideoData.filter(x => subCategoryIds.includes(x.SubCategoryId));
      }
    }
    else {
      this.AllVideoData = this.allVideoOriginalData;
    }
  }
  removeTag(item: FilterCategory) {
    item.IsSelected = false;
    this.selectedTag = this.selectedTag.filter(x => !(x.Category == item.Category && x.Id == item.Id));
    this.filterData();
  }
  clearFilter() {
    this.selectedTag = [];
    this.filterData();
  }
}